import { render, staticRenderFns } from "./A4Print.vue?vue&type=template&id=3fa0a807&scoped=true"
import script from "./A4Print.vue?vue&type=script&lang=js"
export * from "./A4Print.vue?vue&type=script&lang=js"
import style0 from "./A4Print.vue?vue&type=style&index=0&id=3fa0a807&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa0a807",
  null
  
)

export default component.exports